import React from "react";

const CancelModal = ({ open, onBack, onConfirm }) => {
  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/60"
      onClick={onBack}
    >
      <div
        className="bg-white rounded-xl w-[90vw] max-w-sm p-6 flex flex-col items-center gap-6"
        onClick={(e) => e.stopPropagation()}
      >
        <svg className="w-12 h-12 text-red-500" viewBox="0 0 24 24" fill="none">
          <circle
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="2"
          />
          <line
            x1="15"
            y1="9"
            x2="9"
            y2="15"
            stroke="currentColor"
            strokeWidth="2"
          />
          <line
            x1="9"
            y1="9"
            x2="15"
            y2="15"
            stroke="currentColor"
            strokeWidth="2"
          />
        </svg>

        <div className="text-center text-sm leading-relaxed font-semibold">
          매출 분석 데이터
          <br />
          카카오톡 알림 설정
          <br />
          취소 하시겠습니까?
        </div>

        <div className="w-full flex justify-between text-sm">
          <button onClick={onBack} className="flex-1 text-gray-500 text-center">
            이전
          </button>
          <button
            onClick={onConfirm}
            className="flex-1 text-blue-600 text-center font-semibold"
          >
            확인
          </button>
        </div>
      </div>
    </div>
  );
};

export default CancelModal;
